//set up data layer

import { createContext, useContext, useReducer } from "react";

export const StateContext = createContext();

//build  a wrsp i.e provider

export const StateProvider = ({reducer, initialState, children}) => (
    <StateContext.Provider value={useReducer(reducer, initialState)} >
        {children}
    </StateContext.Provider>
)

export const useStateValue = () => useContext(StateContext)